var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-12 align-items-center d-flex pb-2 justify-content-end"
        }
      }),
      _c("board", { attrs: { details: _vm.invoiceDetailsBoard } }),
      _vm.isLoaded
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c(
                "validation-observer",
                {
                  ref: "resultSummary",
                  attrs: {
                    novalidate: "",
                    onsubmit: "return false;",
                    tag: "form"
                  }
                },
                [
                  _c("div", { staticClass: "row mt-5" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("section-title", {
                          attrs: {
                            "has-line": "",
                            title: "Núm. de años/meses en tratamiento"
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "row ml-1 mr-1 align-items-center border-bottom pb-3 mb-3"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1" },
                              [
                                _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-input", {
                                              staticStyle: {
                                                "max-width": "225px"
                                              },
                                              attrs: {
                                                "custom-error-msg":
                                                  "El(los) año(s) es(son) requerido(s).",
                                                disabled: true,
                                                error: errors[0],
                                                "mask-type": "Number",
                                                max: 999,
                                                maxlength: "3",
                                                min: 0,
                                                name:
                                                  _vm.treatmentYearsOrMonthsValue
                                              },
                                              model: {
                                                value:
                                                  _vm.treatmentYearsOrMonthsValue,
                                                callback: function($$v) {
                                                  _vm.treatmentYearsOrMonthsValue = $$v
                                                },
                                                expression:
                                                  "treatmentYearsOrMonthsValue"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    4270960777
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col d-flex justify-content-start"
                              },
                              [
                                _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-radio", {
                                              attrs: {
                                                "custom-error-msg":
                                                  "Favor seleccione",
                                                disabled: true,
                                                error: Boolean(errors[0]),
                                                "is-inline": true,
                                                name: "rbTreatment",
                                                options: _vm.treatmentOptions
                                              },
                                              model: {
                                                value:
                                                  _vm.treatmentYearsOrMonths,
                                                callback: function($$v) {
                                                  _vm.treatmentYearsOrMonths = $$v
                                                },
                                                expression:
                                                  "treatmentYearsOrMonths"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3217630408
                                  )
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("section-title", {
                          attrs: {
                            "has-line": "",
                            title:
                              "La fecha de la primera evaluación realizada que recomendó el servicio"
                          }
                        }),
                        _c("evaluation-row", {
                          attrs: {
                            "add-title": "Presione aquí para añadir evaluación",
                            "custom-error-msg":
                              "Favor seleccionar la evaluación.",
                            "date-title": "Fecha de Evaluación:",
                            "default-date":
                              _vm.catalog.dateOptions.evaluationDate,
                            disabled: _vm.model.isSubmitted,
                            "first-item": _vm.model.evaluation.id == 0,
                            info: _vm.model.evaluation
                          },
                          on: { save: _vm.saveEvaluationHandler }
                        }),
                        _vm.validate
                          ? _c(
                              "div",
                              [
                                _vm.errors.evaluation.invalid
                                  ? _c("error", {
                                      attrs: {
                                        message: _vm.errors.evaluation.message,
                                        variant: "no-border"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mt-5" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("section-title", {
                          attrs: {
                            "has-line": "",
                            title:
                              "Si ha sido reevaluado, precise la información a continuación para cada una de las veces en que fuera evaluado"
                          }
                        }),
                        _vm._l(_vm.model.reevaluations, function(
                          reevaluation,
                          idx
                        ) {
                          return _c(
                            "div",
                            { key: `reevaluation-${idx}`, staticClass: "mb-2" },
                            [
                              _c("evaluation-row", {
                                attrs: {
                                  "add-title":
                                    "Presione aquí para añadir reevaluación",
                                  "confirm-date-title":
                                    "Confirmar Fecha de Reevaluación:",
                                  "custom-error-msg":
                                    "Favor seleccionar la reevaluación.",
                                  "date-options": _vm.availablereevaluationDates(
                                    reevaluation.date
                                  ),
                                  "date-title": "Fecha de Reevaluación:",
                                  disabled: _vm.model.isSubmitted,
                                  "first-item": reevaluation.id == 0,
                                  info: reevaluation,
                                  "re-evaluation": ""
                                },
                                on: {
                                  cancel: function($event) {
                                    return _vm.cancelreevaluationHandler(idx)
                                  },
                                  save: function($event) {
                                    return _vm.savereevaluationHandler(
                                      $event,
                                      idx
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        _vm.showAddEvaluationBtn && !_vm.model.isSubmitted
                          ? _c(
                              "div",
                              { staticClass: "w-100 text-right" },
                              [
                                _c("action-button", {
                                  attrs: {
                                    i: "fas fa-file-plus",
                                    text: "Añadir",
                                    variant: "success mt-2"
                                  },
                                  on: { click: _vm.addreevaluationHandler }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ]),
                  _c("div", { staticClass: "row mt-5" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("section-title", {
                          attrs: {
                            "has-line": "",
                            title:
                              "Desglose las metas a largo plazo desarrolladas en los últimos planes de intervención y el nivel de ejecución alcanzado (logros) en cada uno de los años señalados."
                          }
                        }),
                        _c("long-term-goals", {
                          attrs: {
                            "academic-years": _vm.academicYearsToCreateGoals,
                            disabled: _vm.model.isSubmitted,
                            "execution-level-archieved":
                              _vm.catalog.executionLevelArchieved,
                            goals: _vm.model.goals
                          },
                          on: { alert: _vm.alertHandler }
                        }),
                        _vm.validate
                          ? _c(
                              "div",
                              [
                                _vm.errors.goals.invalid
                                  ? _c("error", {
                                      attrs: {
                                        message: _vm.errors.goals.message,
                                        variant: "no-border"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.goalsCountErrorMessage
                                  ? _c("error", {
                                      attrs: {
                                        message: _vm.goalsCountErrorMessage,
                                        variant: "no-border"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mt-5" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("section-title", {
                          attrs: {
                            "has-line": "",
                            title: "Resuma los resultados de intervención"
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "ml-3" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-text-area", {
                                          staticClass: "mb-2",
                                          attrs: {
                                            "count-classes": [
                                              "d-block text-right"
                                            ],
                                            "custom-error-msg":
                                              "Favor resuma los resultados.",
                                            disabled: _vm.model.isSubmitted,
                                            error: errors[0],
                                            label: "Resuma los resultados:",
                                            maxlength: 3000,
                                            "show-char-count": true
                                          },
                                          model: {
                                            value: _vm.model.resume,
                                            callback: function($$v) {
                                              _vm.$set(_vm.model, "resume", $$v)
                                            },
                                            expression: "model.resume"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1711064161
                              )
                            }),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "color-gray-6 font-14 font-weight-normal"
                                              },
                                              [_vm._v(" Especifique si: ")]
                                            ),
                                            _c("custom-radio", {
                                              attrs: {
                                                "custom-error-msg":
                                                  "Favor especificar.",
                                                disabled: _vm.model.isSubmitted,
                                                error: Boolean(errors[0]),
                                                "is-inline": false,
                                                name: "rbInterventionResume",
                                                options:
                                                  _vm.interventionResumeOptions
                                              },
                                              model: {
                                                value: _vm.model.resumeType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "resumeType",
                                                    $$v
                                                  )
                                                },
                                                expression: "model.resumeType"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3043063077
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mt-5" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("section-title", {
                          attrs: {
                            "has-line": "",
                            title: "Precise las fortalezas del estudiante"
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-secondary-13 p-3 rounded text-center ml-3"
                          },
                          [
                            !_vm.isAddStrengthMode
                              ? _c(
                                  "div",
                                  [
                                    _c("action-button", {
                                      staticClass: "border btn px-5",
                                      attrs: {
                                        disabled: _vm.model.isSubmitted,
                                        i: "fas fa-file-plus color-green",
                                        text:
                                          "Presione aquí para añadir fortalezas"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.isAddStrengthMode = true
                                        }
                                      }
                                    }),
                                    _vm.catalog.addedStrengths.length
                                      ? _c("custom-chips-group", {
                                          staticClass: "text-left",
                                          attrs: {
                                            disabled: _vm.model.isSubmitted,
                                            "no-background": "",
                                            "no-wrap": "",
                                            "object-text": "name",
                                            "on-item-deleted":
                                              _vm.onDeleteStrengthHandler,
                                            "selected-items":
                                              _vm.catalog.addedStrengths,
                                            title:
                                              "Fortaleza(s) seleccionada(s)"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.isAddStrengthMode
                              ? _c(
                                  "div",
                                  [
                                    _c("multi-selection-picker", {
                                      staticClass: "text-left",
                                      attrs: {
                                        "add-item-title-label":
                                          "Añadir nueva Fortaleza a su listado",
                                        "all-items": _vm.getAvailableStrengths,
                                        "allow-item-list-editing": "",
                                        "column-count": 1,
                                        disabled: _vm.model.isSubmitted,
                                        "edit-item-title-label":
                                          "Editar Fortaleza de su listado",
                                        "id-prop-name": "id",
                                        "item-type-name": "fortaleza",
                                        maxlength: "100",
                                        "modify-removes-item": "",
                                        placeholder:
                                          "Escriba aquí para buscar una",
                                        "text-prop-name": "name"
                                      },
                                      on: {
                                        itemAdded: _vm.onAddedStrengthHandler,
                                        itemModified:
                                          _vm.onModifiedStrengthHandler,
                                        itemSelected:
                                          _vm.onSelectedStrengthHandler
                                      }
                                    }),
                                    _vm.catalog.addedStrengths.length
                                      ? _c("custom-chips-group", {
                                          staticClass: "text-left",
                                          attrs: {
                                            disabled: _vm.model.isSubmitted,
                                            "no-background": "",
                                            "no-wrap": "",
                                            "object-text": "name",
                                            "on-item-deleted":
                                              _vm.onDeleteStrengthHandler,
                                            "selected-items":
                                              _vm.catalog.addedStrengths,
                                            title:
                                              "Fortaleza(s) seleccionada(s)"
                                          }
                                        })
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-grow-1 d-flex align-items-center justify-content-end pt-4"
                                      },
                                      [
                                        _c("action-button", {
                                          staticClass: "px-3 mr-2",
                                          attrs: {
                                            disabled: _vm.model.isSubmitted,
                                            i: "fas fa-times-circle",
                                            text: "Cancelar",
                                            variant: "outline-danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.isAddStrengthMode = false
                                            }
                                          }
                                        }),
                                        _c("action-button", {
                                          staticClass: "px-3",
                                          attrs: {
                                            disabled: _vm.model.isSubmitted,
                                            i: "fas fa-arrow-alt-circle-right",
                                            text: "Continuar",
                                            variant: "success"
                                          },
                                          on: { click: _vm.onStrengthContinue }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm.validate
                          ? _c(
                              "div",
                              [
                                _vm.errors.strengths.invalid
                                  ? _c("error", {
                                      attrs: {
                                        message: _vm.errors.strengths.message,
                                        variant: "no-border"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mt-5" },
                      [
                        _c("section-title", {
                          attrs: {
                            "has-line": "",
                            title:
                              "Señale los factores que podrían estar afectando el progreso del estudiante en el proceso de intervención"
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "ml-3" },
                          _vm._l(_vm.studentFactorsOptions, function(factor) {
                            return _c(
                              "div",
                              { key: factor.id },
                              [
                                _c("check-box", {
                                  attrs: {
                                    disabled: _vm.model.isSubmitted,
                                    name: "studentFactors",
                                    text: factor.label
                                  },
                                  model: {
                                    value: factor.check,
                                    callback: function($$v) {
                                      _vm.$set(factor, "check", $$v)
                                    },
                                    expression: "factor.check"
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm.showStudentFactorsOthers
                          ? _c(
                              "div",
                              { staticClass: "ml-5" },
                              [
                                _vm._l(
                                  _vm.studentFactorsOthersOptions,
                                  function(factor) {
                                    return _c(
                                      "div",
                                      { key: factor.id },
                                      [
                                        _c("check-box", {
                                          attrs: {
                                            disabled: _vm.model.isSubmitted,
                                            name: "studentOtherFactors",
                                            text: factor.label
                                          },
                                          model: {
                                            value: factor.check,
                                            callback: function($$v) {
                                              _vm.$set(factor, "check", $$v)
                                            },
                                            expression: "factor.check"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm.isCustomFactorSelected
                                  ? _c(
                                      "div",
                                      { staticClass: "ml-5" },
                                      [
                                        _c("validation-provider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("custom-text-area", {
                                                      attrs: {
                                                        "count-classes": [
                                                          "d-block text-right"
                                                        ],
                                                        "custom-error-msg":
                                                          "Favor llenar este campo.",
                                                        disabled:
                                                          _vm.model.isSubmitted,
                                                        error: errors[0],
                                                        maxlength: 3000,
                                                        "show-char-count": true
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model.otherFactor,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.model,
                                                            "otherFactor",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "model.otherFactor"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3600523652
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.studentFactorHasError
                          ? _c("error", {
                              attrs: {
                                message: "Debe seleccionar un factor.",
                                variant: "no-border"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mt-5" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("section-title", {
                          attrs: {
                            "has-line": "",
                            title:
                              "Si considera que el estudiante requiere continuar en servicio, establezca la necesidad del mismo indicando la meta hacia la que dirigirá las intervenciones, aspectos que está considerando sobre capacidad recuperativa, un estimado de tiempo adicional recomendado y la modalidad."
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "ml-3" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "border-bottom py-2" },
                                          [
                                            _c("custom-radio", {
                                              attrs: {
                                                "custom-error-msg":
                                                  "Favor seleccione",
                                                disabled: _vm.model.isSubmitted,
                                                error: Boolean(errors[0]),
                                                "is-inline": false,
                                                name:
                                                  "rbRequiresContinueService",
                                                options:
                                                  _vm.requiresContinueServiceOptions
                                              },
                                              model: {
                                                value:
                                                  _vm.requiresContinueService,
                                                callback: function($$v) {
                                                  _vm.requiresContinueService = $$v
                                                },
                                                expression:
                                                  "requiresContinueService"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1546793220
                              )
                            }),
                            _vm.showContinueService
                              ? _c(
                                  "div",
                                  { staticClass: "mt-3" },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-text-area", {
                                                  attrs: {
                                                    "count-classes": [
                                                      "d-block text-right"
                                                    ],
                                                    "custom-error-msg":
                                                      "El campo es requerido",
                                                    disabled:
                                                      _vm.model.isSubmitted,
                                                    error: errors[0],
                                                    maxlength: 3000,
                                                    "show-char-count": true
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.continuityServiceComment,
                                                    callback: function($$v) {
                                                      _vm.continuityServiceComment = $$v
                                                    },
                                                    expression:
                                                      "continuityServiceComment"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        4150330066
                                      )
                                    }),
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "color-gray-6 font-14 font-weight-normal"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Término recomendado: "
                                                    )
                                                  ]
                                                ),
                                                _c("custom-radio", {
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "Favor seleccione",
                                                    disabled:
                                                      _vm.model.isSubmitted,
                                                    error: Boolean(errors[0]),
                                                    "is-inline": "",
                                                    name: "rbRecomendedTerm",
                                                    options:
                                                      _vm.recomendedTermOptions
                                                  },
                                                  model: {
                                                    value: _vm.recomendedTerm,
                                                    callback: function($$v) {
                                                      _vm.recomendedTerm = $$v
                                                    },
                                                    expression: "recomendedTerm"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3714663410
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.showContinueService
                              ? _c(
                                  "div",
                                  { staticClass: "mt-3" },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "color-gray-6 font-14 font-weight-normal"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " La capacidad recuperativa del estudiante se estima: "
                                                    )
                                                  ]
                                                ),
                                                _c("custom-radio", {
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "Favor seleccione",
                                                    disabled:
                                                      _vm.model.isSubmitted,
                                                    error: Boolean(errors[0]),
                                                    "is-inline": "",
                                                    name:
                                                      "rbRecoveryStudentCapacity",
                                                    options:
                                                      _vm.recoveryStudentCapacityOptions
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.recoveryStudentCapacity,
                                                    callback: function($$v) {
                                                      _vm.recoveryStudentCapacity = $$v
                                                    },
                                                    expression:
                                                      "recoveryStudentCapacity"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2712627843
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mt-5" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("section-title", {
                          attrs: {
                            "has-line": "",
                            title: "Análisis de resultado de intervención"
                          }
                        }),
                        _c("div", { staticClass: "ml-4 pl-2" }, [
                          _c("div", { staticClass: "row mt-5" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row ml-1 mr-1 align-items-center border-bottom pb-3 mb-3"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-3" },
                                    [
                                      _c("validation-provider", {
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ errors }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-center"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "color-gray-6 font-16 font-weight-normal mr-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Nos recomienda por los pasados: "
                                                          )
                                                        ]
                                                      ),
                                                      _c("custom-input", {
                                                        staticStyle: {
                                                          "max-width": "225px"
                                                        },
                                                        attrs: {
                                                          "custom-error-msg":
                                                            "El(los) año(s) es(son) requerido(s).",
                                                          disabled: true,
                                                          error: errors[0]
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.treatmentYearsOrMonthsValue,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.treatmentYearsOrMonthsValue = $$v
                                                          },
                                                          expression:
                                                            "treatmentYearsOrMonthsValue"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3536305995
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col d-flex justify-content-start"
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ errors }) {
                                                return [
                                                  _c("custom-radio", {
                                                    attrs: {
                                                      "custom-error-msg":
                                                        "Favor seleccione",
                                                      disabled: true,
                                                      error: Boolean(errors[0]),
                                                      "is-inline": true,
                                                      name: "rbTreatment2",
                                                      options:
                                                        _vm.treatmentOptions
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.treatmentYearsOrMonths,
                                                      callback: function($$v) {
                                                        _vm.treatmentYearsOrMonths = $$v
                                                      },
                                                      expression:
                                                        "treatmentYearsOrMonths"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3269595162
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "ml-3" }, [
                            _c(
                              "div",
                              { staticClass: "border-bottom py-2" },
                              [
                                _c("check-box", {
                                  staticClass: "my-2",
                                  attrs: {
                                    disabled: _vm.model.isSubmitted,
                                    text:
                                      "Continuar en el servicio, enfocando el servicio hacia la meta indicada arriba."
                                  },
                                  model: {
                                    value:
                                      _vm.model.analysis.focusInGoalService,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model.analysis,
                                        "focusInGoalService",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "model.analysis.focusInGoalService"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("div", { staticClass: "border-bottom py-2" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("check-box", {
                                      staticClass: "my-2",
                                      attrs: {
                                        disabled: _vm.model.isSubmitted,
                                        text:
                                          "Continuar en el servicio y disminuir la frecuencia a:"
                                      },
                                      model: {
                                        value:
                                          _vm.model.analysis.frequencyTypeCheck,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.analysis,
                                            "frequencyTypeCheck",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.analysis.frequencyTypeCheck"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col d-flex justify-content-end pr-5"
                                  },
                                  [
                                    _c("custom-drop-down", {
                                      staticClass: "w-50",
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.errors.analysisFrequencyType
                                            .message,
                                        disabled: _vm.model.isSubmitted,
                                        error:
                                          _vm.validate &&
                                          _vm.errors.analysisFrequencyType
                                            .invalid,
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.catalog.frequencyTypes,
                                        placeholder: "Seleccione"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.model.analysis.frequencyTypeCheck = !!_vm
                                            .model.analysis.frequencyTypeId
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.model.analysis.frequencyTypeId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.analysis,
                                            "frequencyTypeId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.analysis.frequencyTypeId"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]),
                            _c("div", { staticClass: "border-bottom py-2" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("check-box", {
                                      staticClass: "my-2",
                                      attrs: {
                                        disabled: _vm.model.isSubmitted,
                                        text:
                                          "Continuar en el servicio en una modalidad diferente:"
                                      },
                                      model: {
                                        value:
                                          _vm.model.analysis
                                            .serviceModalityCheck,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.analysis,
                                            "serviceModalityCheck",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.analysis.serviceModalityCheck"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col d-flex justify-content-end pr-5"
                                  },
                                  [
                                    _c("custom-drop-down", {
                                      staticClass: "w-50",
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.errors.analysisServiceModality
                                            .message,
                                        disabled: _vm.model.isSubmitted,
                                        error:
                                          _vm.validate &&
                                          _vm.errors.analysisServiceModality
                                            .invalid,
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.catalog.serviceModalities,
                                        placeholder: "Seleccione"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.model.analysis.serviceModalityCheck = !!_vm
                                            .model.analysis.serviceModalityId
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.model.analysis.serviceModalityId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.analysis,
                                            "serviceModalityId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.analysis.serviceModalityId"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]),
                            this.isNewFeaturesImprovementEnabled
                              ? _c(
                                  "div",
                                  { staticClass: "border-bottom py-2" },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col" },
                                        [
                                          _c("check-box", {
                                            staticClass: "my-2",
                                            attrs: {
                                              disabled: _vm.model.isSubmitted,
                                              text:
                                                "Continuar con el servicio en una duración diferente:"
                                            },
                                            model: {
                                              value:
                                                _vm.model.analysis
                                                  .serviceDurationCheck,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model.analysis,
                                                  "serviceDurationCheck",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.analysis.serviceDurationCheck"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col d-flex justify-content-end pr-5"
                                        },
                                        [
                                          _c("custom-drop-down", {
                                            staticClass: "w-50",
                                            attrs: {
                                              "custom-error-msg":
                                                _vm.errors
                                                  .analysisServiceDurationmessage,
                                              disabled: _vm.model.isSubmitted,
                                              error:
                                                _vm.validate &&
                                                _vm.errors
                                                  .analysisServiceDuration
                                                  .invalid,
                                              fieldkey: "id",
                                              fieldname: "name",
                                              options:
                                                _vm.catalog.serviceDurations,
                                              placeholder: "Seleccione"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.model.analysis.serviceDurationCheck = !!_vm
                                                  .model.analysis
                                                  .serviceDurationId
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.model.analysis
                                                  .serviceDurationId,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model.analysis,
                                                  "serviceDurationId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.analysis.serviceDurationId"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _c("div", { staticClass: "border-bottom py-2" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("check-box", {
                                      staticClass: "my-2",
                                      attrs: {
                                        disabled: _vm.model.isSubmitted,
                                        text:
                                          "Comenzar y completar el alta en un periodo estimado de:"
                                      },
                                      model: {
                                        value: _vm.model.analysis.periodCheck,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.analysis,
                                            "periodCheck",
                                            $$v
                                          )
                                        },
                                        expression: "model.analysis.periodCheck"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col d-flex justify-content-end pr-5"
                                  },
                                  [
                                    _c("custom-input", {
                                      staticClass: "pr-3",
                                      staticStyle: { "max-width": "225px" },
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.errors.analysisPeriodAmount
                                            .message,
                                        disabled: _vm.model.isSubmitted,
                                        error:
                                          _vm.validate &&
                                          _vm.errors.analysisPeriodAmount
                                            .invalid
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.model.analysis.periodCheck =
                                            !!_vm.model.analysis.period ||
                                            !!_vm.model.analysis.periodTypeId
                                        }
                                      },
                                      model: {
                                        value: _vm.model.analysis.period,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.analysis,
                                            "period",
                                            $$v
                                          )
                                        },
                                        expression: "model.analysis.period"
                                      }
                                    }),
                                    _c("custom-drop-down", {
                                      staticClass: "w-50",
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.errors.analysisPeriod.message,
                                        disabled: _vm.model.isSubmitted,
                                        error:
                                          _vm.validate &&
                                          _vm.errors.analysisPeriod.invalid,
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.catalog.periods,
                                        placeholder: "Seleccione"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.model.analysis.periodCheck =
                                            !!_vm.model.analysis.period ||
                                            !!_vm.model.analysis.periodTypeId
                                        }
                                      },
                                      model: {
                                        value: _vm.model.analysis.periodTypeId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.analysis,
                                            "periodTypeId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.analysis.periodTypeId"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]),
                            _c(
                              "div",
                              { staticClass: "border-bottom py-2" },
                              [
                                _c("check-box", {
                                  staticClass: "my-2",
                                  attrs: {
                                    disabled: _vm.model.isSubmitted,
                                    text:
                                      "Continuar el servicio con plan que incluya objetivos hacia el alta de la intervención."
                                  },
                                  model: {
                                    value:
                                      _vm.model.analysis
                                        .focusInObjectiveService,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model.analysis,
                                        "focusInObjectiveService",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "model.analysis.focusInObjectiveService"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "border-bottom py-2" },
                              [
                                _c("check-box", {
                                  staticClass: "my-2",
                                  attrs: {
                                    disabled: _vm.model.isSubmitted,
                                    text:
                                      "Reevaluar para actualizar datos que abonen al curso del tratamiento.."
                                  },
                                  model: {
                                    value:
                                      _vm.model.analysis.reevaluationForUpdates,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model.analysis,
                                        "reevaluationForUpdates",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "model.analysis.reevaluationForUpdates"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm.validate
                            ? _c(
                                "div",
                                [
                                  _vm.errors.analysis.invalid
                                    ? _c("error", {
                                        attrs: {
                                          message: _vm.errors.analysis.message,
                                          variant: "no-border"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "row mt-5 ml-2 mb-5" },
                    [
                      _c("section-title", {
                        attrs: {
                          "has-line": "",
                          title: "Firma de Especialista"
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "col-12 ml-2" },
                        [
                          _c("SpecialistInformationWriter", {
                            attrs: {
                              disabled: _vm.model.isSubmitted,
                              "is-new-features-improvement-enabled":
                                _vm.isNewFeaturesImprovementEnabled,
                              "service-specialists": _vm.serviceSpecialists,
                              "writer-specialists": _vm.writerSpecialists
                            },
                            on: {
                              getSpecialistDetail: _vm.getSpecialistDetail
                            },
                            model: {
                              value: _vm.specialistModel,
                              callback: function($$v) {
                                _vm.specialistModel = $$v
                              },
                              expression: "specialistModel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }